import { displayDate } from "~/plugins/functions/display";

// For DTO Preset
export interface IModelGETWorkflowRuntimeRequest {
  orderBy: string;
  orderType: string;
  count: boolean;
  page: number;
  limit: number;
}

// For DTO Workflow
export interface IModelGETWorkflowRuntimeResponse {
  id: number;
  runtime: string;
  nodes: string;
  edges: string;
  className: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;
}

export class ModelGETWorkflowRuntime {
  id: number;
  runtime: string;
  nodes: string;
  edges: string;
  className: string;
  createdAt: string | Date;
  createdBy: any;
  updatedAt: string | Date;
  updatedBy: any;

  type: string;
  displayCreatedAt: string;
  displayUpdatedAt: string;

  constructor(props = {} as IModelGETWorkflowRuntimeResponse) {
    props = props ?? {} as IModelGETWorkflowRuntimeResponse;
    this.id = props.id || 0;
    this.runtime = props.runtime || '';
    this.nodes = props.nodes;
    this.edges = props.edges;
    this.className = props.className;
    this.createdAt = props.createdAt || '';
    this.createdBy = props.createdBy || null;
    this.updatedAt = props.updatedAt || '';
    this.updatedBy = props.updatedBy || null;


    this.type = 'workflow';
    this.displayCreatedAt = displayDate(this.createdAt, {
      isTime: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTime: true
    });
  }
}

// For DTO Workflow
export interface IModelGETWorkflowRuntimeIdResponse {
  id: number;
  runtime: string;
  nodes: string;
  edges: string;
  className: string;
}

export class ModelGETWorkflowRuntimeId {
  id: number;
  runtime: string;
  nodes: string;
  edges: string;
  className: string;

  type: string;

  constructor(props = {} as IModelGETWorkflowRuntimeIdResponse) {
    props = props ?? {} as IModelGETWorkflowRuntimeIdResponse;
    this.id = props.id || 0;
    this.runtime = props.runtime || '';
    this.nodes = props.nodes;
    this.edges = props.edges;
    this.className = props.className;

    this.type = 'workflow'
  }
}

